<template>
  <v-container>
    <v-breadcrumbs :items="breadcrumbs" class="pl-0 py-1">
      <template v-slot:divider>
        <v-icon>mdi-chevron-right</v-icon>
      </template>
    </v-breadcrumbs>
    <v-form ref="editNoteForm">
    <v-data-table
      disable-pagination
      hide-default-footer
      :headers="tableHeaders"
      :items="files"
      :loading="loading"
      loading-text="ローディング..."
      no-data-text="該当データがありません。"
      class="elevation-1 mt-3"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>
            <b>オルソ画像一覧</b>
            
            <div class="mess-warning" v-html="message">
              <!-- <v-icon
              >mdi-alert-outline</v-icon>
              Lasファイルがありません。 -->
            </div>
            
          </v-toolbar-title>
        </v-toolbar>
      </template>
      <template v-slot:item.thumbnail_color_path="{ item }">
        <v-img
            lazy-src="../../assets/images/no-image.png"
            class="my-2"
            :style="item.thumbnail_color_path? 'background: black' : null"
            max-width="107"
            :aspect-ratio="4 / 3"
            :src="item.created_by_app ? item.thumbnail_color_path : ''"
            @click="editArrayPosition(item)"
        ></v-img>
      </template>
      <template v-slot:item.note="props">
        <v-edit-dialog
          :return-value.sync="props.item.note"
          @save="save(props.item)"
          @open="open(props.item.note)"
        >
          {{ props.item.note }}

          <template v-slot:input>
            <v-text-field
              v-model="editNote"
              :rules="[max191chars]"
              single-line
              counter
            ></v-text-field>
          </template>
        </v-edit-dialog>
      </template>
      <template v-slot:item.file_name="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{on, attrs}">
            <v-btn class="not-button-name download" text v-bind="attrs" v-on="on">
              <span
                class="text-truncate"
                style="max-width: 200px;"
              >{{ getTextFileName(item) }}
              </span>
            </v-btn>
          </template>
           <h5>{{ getTextFileName(item) }}</h5>
        </v-tooltip>
      </template>
      <template v-slot:item.created_user="{ item }">
        {{ item.created_user.split('@')[0] }}
      </template>
      <template v-slot:item.status="{ item }">
        <v-chip
            v-if="item.status === 'NEW'"
            color="default"
            small
        >
          {{ getStatusText(item.status) }}
        </v-chip>
        <v-chip
            v-if="item.status === 'ARRAY_QUEUEING'"
            color="secondary"
            small
        >
          {{ getStatusText(item.status) }}
        </v-chip>
        <v-chip
            v-if="item.status === 'ARRAY_PROCESSING'"
            color="primary"
            small
        >
          {{ getStatusText(item.status) }}
        </v-chip>
        <v-chip
            v-if="item.status === 'ARRAY_COMPLETED'"
            color="success"
            small
        >
          {{ getStatusText(item.status) }}
        </v-chip>
        <v-chip
            v-if="item.status === 'ARRAY_SKIP'"
            color="orange"
            small
        >
          {{ getStatusText(item.status) }}
        </v-chip>
        <v-chip
            v-if="item.status === 'ARRAY_ERROR'"
            color="error"
            small
        >
          {{ getStatusText(item.status) }}
        </v-chip>
      </template>
      
      <template v-slot:item.actions="{ item }">
        <div class="text-left">
          <v-btn color="primary" text @click="editArrayPosition(item)">アレイ詳細</v-btn>
          <v-btn color="error" text @click.stop="confirmDeleteArrayPosition(item)">削除</v-btn>
          <v-spacer></v-spacer>
          <div
            v-if="item.status === 'ARRAY_COMPLETED' || item.status === 'ARRAY_ERROR' || item.status === 'ARRAY_SKIP'"
          >
            <v-btn class="not-button" text>H2P:</v-btn>
            <v-tooltip bottom>
              <template v-slot:activator="{on, attrs}">
                <v-btn color="primary" text v-bind="attrs" v-on="on" @click.stop="showCreateH2pDialog(item)"><v-icon>mdi-text-box-plus</v-icon></v-btn>
              </template>
              <h5>H2Pファイルを作成</h5>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{on, attrs}">
                <v-btn color="primary" text v-bind="attrs" v-on="on" @click.stop="showCreateCSVDialog(item)"><v-icon>mdi-file-delimited</v-icon></v-btn>
              </template>
              <h5>CSVファイルを作成</h5>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{on, attrs}">
                <v-btn v-if="item.checkHasH2p" color="primary" text v-bind="attrs" v-on="on" @click.stop="showListH2P(item)"><v-icon>mdi-download</v-icon></v-btn>
              </template>
              <h5>H2P結果</h5>
            </v-tooltip>
          </div>
          <v-spacer></v-spacer>
          <div>
            <v-btn class="not-button" text >点群:</v-btn>
            <v-tooltip bottom>
              <template v-slot:activator="{on, attrs}">
                <v-btn color="primary" text v-bind="attrs" v-on="on" @click.stop="showCreatePvsystLasDialog(item)"><v-icon>mdi-text-box-plus</v-icon></v-btn>
              </template>
              <h5>点群整理：外れ値を削除し、周辺地形の点群も作成する</h5>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{on, attrs}">
                <v-btn color="primary" text v-bind="attrs" v-on="on" @click.stop="showUploadLasFileDialog(item)"><v-icon>mdi-upload</v-icon></v-btn>
              </template>
              <h5>点群ファイルをアップロード</h5>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{on, attrs}">
                <v-btn v-if="item.checkHasPvsystLas" color="primary" text v-bind="attrs" v-on="on" @click.stop="showListPvsystLas(item)"><v-icon>mdi-download</v-icon></v-btn>
              </template>
              <h5>点群整理の結果</h5>
            </v-tooltip>
          </div>
        </div>
      </template>
    </v-data-table>
    </v-form>
    <v-snackbar
      v-model="snack"
      :timeout="3000"
      :color="snackColor"
    >
      {{ snackText }}
    </v-snackbar>
    <h2p-create-file-dialog
    v-model="createH2pDialog"
    :las_file="las_file"
    :array_position_id ="array_position_id"
    :blur_size="blur_size"
    ></h2p-create-file-dialog>
    <csv-create-file-dialog
    v-model="createCSVDialog"
    :las_file="las_file"
    :array_position_id ="array_position_id"
    :blur_size="blur_size"
    ></csv-create-file-dialog>
    <h2p-upload-lasfile-dialog
    v-model="uploadLasFileDialog"
    :folder_id="folder_id"
    >
    </h2p-upload-lasfile-dialog>
    <h2p-create-pvsyst-las-dialog
    v-model="createPvsystLasDialog"
    :folder_id="folder_id"
    :las_file="las_file"
    :array_position_id ="array_position_id"
    >
    </h2p-create-pvsyst-las-dialog>
    <h2p-show-pvsyst-las-dialog
    v-model="showPvsystLasDialog"
    :pvsyst_las_data ="pvsyst_las_data"
    ></h2p-show-pvsyst-las-dialog>
    <h2p-show-file-dialog
    v-model="showH2pFileDialog"
    :h2p_data ="h2p_data"
    ></h2p-show-file-dialog>
  </v-container>
</template>
<script>
import {store} from "@/store";
import H2pCreateFileDialog from '../dialog/H2pCreateFileDialog.vue';
import CSVCreateFileDialog from '../dialog/CSVCreateFileDialog.vue';
import H2pUploadLasFileDialog from '../dialog/H2pUploadLasFileDialog.vue';
import H2pCreatePvsystLasDialog from '../dialog/H2pCreatePvsystLasDialog.vue';
import H2pShowPvsystLasDialog from '../dialog/H2pShowPvsystLasDialog.vue';
import H2pShowFileDialog from '../dialog/H2pShowFileDialog.vue';

export default {
  name: "Data",
  components:{
    'h2p-create-file-dialog': H2pCreateFileDialog,
    'csv-create-file-dialog': CSVCreateFileDialog,
    'h2p-upload-lasfile-dialog': H2pUploadLasFileDialog,
    'h2p-create-pvsyst-las-dialog': H2pCreatePvsystLasDialog,
    'h2p-show-pvsyst-las-dialog': H2pShowPvsystLasDialog,
    'h2p-show-file-dialog': H2pShowFileDialog,
  },
  data() {
    return {
      sharedState: store.state,
      message: null,
      breadcrumbs: [
        {
          text: "発電所一覧",
          disabled: false,
          exact: true,
          to: "/h2p",
        },
        {
          text: "",
        },
      ],
      filter: {
        plant_id: this.$route.params.plantId,
      },
      loading: true,
      tableHeaders: [
        {
          text: "サムネイル",
          sortable: false,
          value: "thumbnail_color_path",
          width: "110px",
        },
        {
          text: "備考",
          sortable: false,
          value: "note",
          width: "20%",
        },
        {
          text: "ファイル名",
          sortable: false,
          value: "file_name",
        },
        {
          text: "作成者",
          sortable: false,
          value: "created_user",
        },
        {
          text: "日付",
          sortable: true,
          value: "created_at",
          width: "12%",
        },
        {
          text: "状態",
          sortable: false,
          value: "status",
        },
        {
          text: "アクション",
          sortable: false,
          value: "actions",
          align: "center",
          width: "300px",
        },
      ],
      files: [],
      check_file_las: [],
      createH2pDialog: false,
      createCSVDialog: false,
      las_file: [],
      array_position_id: null,
      blur_size: null,
      uploadLasFileDialog: false,
      folder_id: null,
      snack: false,
      snackColor: '',
      snackText: '',
      max191chars: v => v.length <= 191 || '191文字以内で入力してください。',
      editNote: null,
      createPvsystLasDialog: false,
      showPvsystLasDialog: false,
      pvsyst_las_data: null,
      showH2pFileDialog: false,
      h2p_data: null,
    };
  },

  methods: {
    resetData() {
      this.loading = true;
      this.files = [];
    },
    getFiles() {
      this.resetData();
      this.axios.post("/api/h2p/files", this.filter).then((response) => {
        this.loading = false;
        this.files = response.data.file_tiffs;
        this.check_file_las = response.data.las_files;
        this.breadcrumbs[1].text = response.data.plantInfo.name;
        if(this.check_file_las.length == 0){
            this.message = 'Lasファイルがありません。'
        }
      });
    },

    showCreateH2pDialog(item) {
      if(item != null){
        this.getLasFile(item, 'h2p');
      }
    },
    
    getArrayPosition(item) {
      this.axios
        .post(
          "/api/h2p/update-status", {'file': item}
        )
        .then((response) => {
          if(response.data.status == true) {
            item.status = "ARRAY_QUEUEING";
          }
        })
        
    },

    editArrayPosition(item) {
      this.$router.push('/h2p/' + item.folder_id + '/position/' + item.id);
    },
    getStatusText(type) {
      const statusTypes = [
        { text: "未抽出", value: "NEW" },
        { text: "抽出待ち", value: "ARRAY_QUEUEING"},
        { text: "抽出中", value: "ARRAY_PROCESSING" },
        { text: "抽出完了", value: "ARRAY_COMPLETED"},
        { text: "抽出スキップ", value: "ARRAY_SKIP"},
        { text: "エラー", value: "ARRAY_ERROR"},
      ];
      return statusTypes.find(x => x.value == type).text;
    },

    download(path) {
      this.axios
      .post("/api/h2p/download", { path: path })
      .then((response) => {
        window.location.href = response.data;
      })
      .catch(() => {
        store.showErrorDialog("エラーが発生しました。再度試してください。");
      });
    },
    confirmDeleteH2PFile(item) {
      const confirmDialog = {
        title: '削除確認',
        content:  "データを削除します。よろしいですか。",
        onAgree: () => this.deleteH2PFile(item),
        onDisagree: null,
      };
      store.showConfirmDialog(confirmDialog);
    },
    deleteH2PFile(item) {
      this.axios
      .delete("/api/h2p/"+item.id)
      .then((response) => {
        if(response.status === 204) {
          store.showSuccessDialog("データ削除が完了しました。");
          this.getFiles();
        }
      })
      .catch(() => {
        store.showErrorDialog('エラーが発生しました。再度試してください。');
      });
    },
    viewFolderDroneDeploy(item) {
      this.axios.get("/api/folder/layers-info/" + item.folder_id)
          .then(() => {
            this.$router.push('/map/' + item.folder_id);
          }).catch(() => {
            store.showErrorDialog('マップデータはありません。');
          });
    },
    getTextFileName(item) {
      return item.file_app +'_'+ item.file_name;
    },
    downloadCSV(item) {
      this.axios.get('/api/h2p/csv/' + item.id)
      .then(response => {
        // Create CSV content
        const data = response.data;
        const list = data.coordinate;
        let csvContent = "data:text/csv;charset=utf-8,";
        csvContent += "OBJECTID,Id,ORIG_OID,POINT_X,POINT_Y,POINT_Z\r\n";
        list.forEach(item => {
          const Id = item.Id;
          item.points.forEach(element => {
            csvContent += `${element.OBJECTID},${Id},${element.ORIG_OID},${element.POINT_X},${element.POINT_Y},${element.POINT_Z}\r\n`;
          });
         
        });
        // Download File
        const fileName = 'POINT.csv';
        const encodedUri = encodeURI(csvContent);
        const link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", fileName);
        document.body.appendChild(link); // Required for FF
        link.click();
      })
    },
    showCreateCSVDialog(item) {
      if(item != null){
        this.getLasFile(item, 'csv');
      }
    },
    showUploadLasFileDialog(item) {
      this.folder_id = item.folder_id;
      this.uploadLasFileDialog = true;
    },
    confirmDeleteArrayPosition(item) {
      const confirmDialog = {
        title: '削除確認',
        content:  "データを削除します。よろしいですか。",
        onAgree: () => this.deleteArrayPosition(item),
        onDisagree: null,
      };
      store.showConfirmDialog(confirmDialog);
    },
    deleteArrayPosition(item) {
      this.axios
      .delete("/api/h2p/file/"+item.id)
      .then((response) => {
        if(response.status === 204) {
          store.showSuccessDialog("データ削除が完了しました。");
          this.getFiles();
        }
      })
      .catch(() => {
        store.showErrorDialog('エラーが発生しました。再度試してください。');
      });
    },
    save (item) {
      if (this.$refs.editNoteForm.validate()) {
        this.axios
        .put("/api/h2p/update-note/"+item.id, {data: this.editNote})
        .then(() => {
          item.note = this.editNote;
          this.snack = true;
          this.snackColor = 'success';
          this.snackText = '備考データが保存されました';
        })
        .catch(() => {
          this.snack = true;
          this.snackColor = 'error';
          this.snackText = 'エラーが発生しました。再度試してください。';
        });
      } else{
        this.snack = true;
        this.snackColor = 'error';
        this.snackText = 'エラーが発生しました。再度試してください。';
      }
    },
    open (note) {
      this.editNote = note;
    },
    showCreatePvsystLasDialog(item) {
      if(item != null){
        this.getLasFile(item, 'pvsyst_las');
      }
    },
    getLasFile(item, check) {
      const folder_id = item["folder_id"];
      this.las_file = [];
      this.axios.post("/api/h2p/get-las", {'folder_id': folder_id}).then((response) => {
        this.las = response.data;
        this.array_position_id = item.id;
        this.las.forEach(element => {
          const data = [];
          data['text'] = element.filename;
          data['value'] = element.path;
          this.las_file.push(data);
        });
        if(item.blur_size != null) {
          this.blur_size = item.blur_size;
        }
        if (check == 'h2p') {
          this.createH2pDialog = true;
        }else if (check == 'csv') {
          this.createCSVDialog = true;
        }else {
          this.createPvsystLasDialog = true;
        }
      });
    },
    showListPvsystLas(item) {
      this.showPvsystLasDialog = true;
      this.pvsyst_las_data = item;
    },
    showListH2P(item) {
      this.showH2pFileDialog = true;
      this.h2p_data = item;
    },
  },
  created() {
    this.getFiles();
  }
};
</script>
<style lang="scss" scoped>
.download {
  font-weight: normal !important;
  text-transform: none !important;
  color: #1976d2 !important;
}
.mess-warning {
  font-size: 14px;
}
.mess-warning {
  color: orangered;
}
.v-text-field.v-text-field--enclosed .v-text-field__details {
   display: none;
}
.v-small-dialog__activator__content {
  display: block;
}
.v-small-dialog__activator {
  width: 100%;
  padding: 20px 0px;
}
.not-button {
  cursor: default;
  pointer-events: none;
  color: #000 !important;
}
.not-button-name {
  color: #000 !important;
}
</style>
